import { useEffect } from 'react';

export type PayeeDrawerRefreshEventDetail = {
  apPayeeId: string;
};

export type PayeeDrawerRefreshEvent =
  CustomEvent<PayeeDrawerRefreshEventDetail>;

export const useReceivePayeeId = (
  callback?: (value: PayeeDrawerRefreshEventDetail) => void
) => {
  useEffect(() => {
    const handlePayeeId = (event: Event) => {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      const e = event as PayeeDrawerRefreshEvent;
      callback?.({ ...e.detail });
    };
    window.addEventListener('payee-drawer-change-id', handlePayeeId);

    return () => {
      window.removeEventListener('payee-drawer-change-id', handlePayeeId);
    };
  }, [callback]);
};
